// Pagamentos de pedido: categorias, formatação e leitura de valores digitados
import { fmtBRL, fmtUSD, fmtRMB } from './helpers';

export const CAT_LABELS = {
  fornecedor:  'Fornecedor (FOB)',
  frete:       'Frete',
  impostos:    'Impostos',
  despachante: 'Despachante',
  armazenagem: 'Armazenagem',
  taxas:       'Taxas / outros',
};
export const CATS = Object.keys(CAT_LABELS);

// Fornecedor e frete são negociados em moeda estrangeira: o saldo deles é
// mostrado na moeda do pagamento. Impostos, despachante, armazenagem e taxas
// são pagos em reais e ficam sempre em BRL.
export const FOREIGN_CATS = ['fornecedor', 'frete'];
export const fmtIn = (cur, v) => (cur === 'RMB' ? fmtRMB(v) : cur === 'BRL' ? fmtBRL(v) : fmtUSD(v));


// Valor digitado do jeito brasileiro: "52.345,67", "52.345", "R$ 1.200",
// "-R$ 21.600,00" (extrato do banco) ou "21600.5". Com vírgula, os pontos são
// milhar; sem vírgula, ponto seguido de grupos de 3 dígitos também é milhar
// ("52.345" = cinquenta e dois mil). É sempre dinheiro que saiu — sem sinal.
export function parseBRL(v) {
  let t = String(v ?? '').replace(/R\$|US\$|\$|¥|USD|RMB|CNY|BRL|\s|\u00a0|[()+\-\u2212]/gi, '');
  if (!t) return 0;
  // Formato americano — vírgula de milhar e ponto decimal por último, como o
  // próprio saldo em USD/RMB é exibido ("3,200.00"): tira as vírgulas
  if (t.includes(',') && t.includes('.') && t.lastIndexOf('.') > t.lastIndexOf(',')) t = t.replace(/,/g, '');
  else if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(t)) t = t.replace(/\./g, '');
  const n = parseFloat(t);
  return Number.isFinite(n) ? n : 0;
}
// Câmbio: aceita vírgula ou ponto como decimal ("5,4321" ou "5.4321")
export function parseRate(v) {
  const n = parseFloat(String(v ?? '').replace(/\s/g, '').replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : 0;
}
export const fmtBRLInput = (n) => n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
